export default "__VITE_ASSET__BIRlwDX9__"